<template>
  <div v-if="elector" class="meetingmanualvote-container">
    <v-card elevation="4" class="mb-4 mt-4">
      <v-card-title>
        {{ elector.name }}
      </v-card-title>
      <v-card-text>
        {{ elector.id }}
      </v-card-text>
    </v-card>
    <v-card elevation="4">
      <v-card-text v-for="point in decisionPoints" :key="point.id">
        <v-card-title>{{ point.text }}</v-card-title>
        <div v-for="ballot in elector.ballots" :key="ballot">
          <div>Röstsedel: {{ ballot }}</div>
          <v-col v-if="point.alternatives">
            <v-card-text style="padding-top: 0">
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-left">Alternativ</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="alt in point.alternatives" :key="alt.id">
                    <td>{{ alt }}</td>
                    <td>
                      <v-checkbox
                        :disabled="shouldDisable(point.id, ballot, alt)"
                        :input-value="voteForElection(point.id, ballot, alt)"
                        @change="updateVoteForElection(point.id, ballot, alt)"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-col>

          <v-col v-else>
            <v-card-text style="padding-top: 0">
              <v-simple-table>
                <thead>
                  <tr>
                    <th class="text-left">Alternativ</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Ja</td>
                    <td>
                      <v-checkbox
                        :input-value="voteForElection(point.id, ballot, 'yes')"
                        @change="updateVoteForElection(point.id, ballot, 'yes')"
                      ></v-checkbox>
                    </td>
                  </tr>
                  <tr>
                    <td>Nej</td>
                    <td>
                      <v-checkbox
                        :input-value="voteForElection(point.id, ballot, 'no')"
                        @change="updateVoteForElection(point.id, ballot, 'no')"
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>
          </v-col>
        </div>
      </v-card-text>
    </v-card>
    <v-card elevation="4" class="mb-4 mt-4">
      <v-card-text>
        <v-btn color="green" @click="votingDone">
          <div class="icon-button-container">
            <div class="icon-button-text">
              Klar
            </div>
            <div class="icon-button-icon">
              <v-icon right style="color: green;">
                mdi-check
              </v-icon>
            </div>
          </div>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
  <div v-else-if="done" class="meetingmanualvote-container">
    <v-card elevation="4" class="mb-4 mt-4">
      <v-card-title>Tack för din röst.</v-card-title>
      <v-card-text>
        Tack för din röst. Du kan nu lämna tillbaks enheten till
        mötesfunktionär.
      </v-card-text>
    </v-card>
    <v-card elevation="4" class="mb-4 mt-4">
      <v-card-text>
        <v-btn color="red" @click="votingCancel">
          <div class="icon-button-container">
            <div class="icon-button-text">
              Enheten är återlämnad till funktionär.
            </div>
          </div>
        </v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      subscription: null,
      meeting: null,
      manualMembers: []
    };
  },
  computed: {
    meetingId() {
      return this.$route.params.meetingId;
    },
    electorSsn() {
      return this.$route.params.electorSsn;
    },
    elector() {
      const electors = this.$store.getters["meetings/getElectors"];
      return electors.find(e => e.id === this.electorSsn);
    },
    manualVotes() {
      return this.$store.getters["meetings/getManualVotes"];
    },
    decisionPoints() {
      return this.$store.getters["meetings/getDecisionPoints"].filter(
        election => election.opened !== null && election.closed === null
      );
    },
    done() {
      return this.electorSsn === "done";
    }
  },
  watch: {
    meetingId(newMeetingId) {
      console.log(newMeetingId);
    }
  },
  methods: {
    findVote: function(electionId, ballot) {
      const vote = this.manualVotes.find(
        v =>
          v.meetingId === this.$route.params.meetingId &&
          v.electionId === electionId &&
          v.id === ballot
      );
      if (vote) {
        return vote.vote;
      } else {
        return [];
      }
    },
    shouldDisable: function(electionId, ballot, value) {
      const election = this.decisionPoints.find(o => o.id === electionId);
      if (election.choices) {
        const vote = this.findVote(electionId, ballot);
        if (election.choices <= vote.length) {
          return !vote.includes(value);
        }
      }
      return false;
    },
    voteForElection: function(electionId, ballot, value) {
      const vote = this.findVote(electionId, ballot);

      return vote.includes(value);
    },
    async updateVoteForElection(electionId, ballot, value) {
      const election = this.decisionPoints.find(o => o.id === electionId);
      const auth = this.$store.getters["auth/auth"];
      let vote = this.findVote(electionId, ballot);
      if (vote.includes(value)) {
        vote = vote.filter(o => o !== value);
      } else {
        if (election.choices) {
          if (election.choices <= vote.length) {
            return;
          }
          vote.push(value);
        } else {
          vote = [value];
        }
      }

      if (vote.length > 0) {
        await this.$store.dispatch("meetings/createManualVote", {
          meetingId: this.meetingId,
          electionId: electionId,
          adminSsn: auth.uid,
          electorSsn: this.electorSsn,
          ballot: ballot,
          value: vote
        });
      } else {
        await this.$store.dispatch("meetings/deleteManualVote", {
          meetingId: this.meetingId,
          electionId: electionId,
          ballot: ballot
        });
      }
    },
    votingDone: function() {
      this.$router.push({
        name: "manualMemberVote",
        params: { meetingId: this.$route.params.meetingId, electorSsn: "done" }
      });
    },
    votingCancel: function() {
      this.$router.push({
        name: "manualvotes",
        params: { meetingId: this.$route.params.meetingId }
      });
    }
  },
  mounted: async function() {
    console.log("mounted");

    await this.$store.dispatch(
      "meetings/decisionListener",
      this.$route.params.meetingId
    );
    await this.$store.dispatch(
      "meetings/electorsListener",
      this.$route.params.meetingId
    );
    const auth = this.$store.getters["auth/auth"];

    await this.$store.dispatch("meetings/manualVotesListener", {
      meetingId: this.$route.params.meetingId,
      userId: auth.uid
    });
  }
};
</script>

<style>
.meetingmanualvote-container {
  height: 100vh;
  margin-left: 100px;
  /*margin-top: 100px;*/
  /*margin-bottom: 100px;*/
  margin-right: 100px;
  overflow-y: scroll;
}
</style>
